import React from "react";
import {
    Container,
    Card
} from 'reactstrap';

import Dashheader from "components/Headers/Dashheader";

import jwt_decode from 'jwt-decode';
import { Mixpanel } from "../../../Mixpanel/mixpanel";

import { connect } from 'react-redux';
import CSILogs from "components/CustomerSatisfaction/CSILogs";
import CustomerSatisfactionChart from "components/DashboardGraphs/CustomerSatisfactionChart";

const mapStateToProps = state => {
    return {
        outlet: state.outletCode.outletCode,
        time: state.time.time,
    };
};

class CSITab extends React.Component {
    constructor(props) {
        super(props);
        Mixpanel.track('Customer Satisfaction Tab', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email });
        Mixpanel.time_event('Customer Satisfaction Tab Time', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email });
    }
    componentWillUnmount() {
        Mixpanel.track('Customer Satisfaction Tab Time', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email });
    }
    render() {
        return (
            <Card>
                <Dashheader title="Customer Satisfaction" />
                <Container className="mt--6" fluid>
                    <Card>
                        <CustomerSatisfactionChart />
                    </Card>
                    <CSILogs />
                </Container>
            </Card>
        );
    }
}

export default connect(
    mapStateToProps,
)(CSITab);